<template>
  <v-container fluid>
    <!-- 검색 결과가 있을경우 -->
    <div class="library-keyword-lists">
      <!-- 검색 결과가 없는경우 -->
      <NoData v-if="searchKeywords.length === 0"
              no-data-text="최근 검색내역이 없습니다." />
      <template v-else>
        <div class="library-title-block">
          <h2 class="tit">최근 검색어</h2>
          <v-btn text :ripple="false" class="btn-allView" @click="delCookie()">전체삭제</v-btn>
        </div>
        <ul class="keyword-list">
          <li class="keyword-list-item"
              v-for="(item, index) in searchKeywords"
              :key="index">
            <v-btn text plain :ripple="false"
                   style="min-width: 0"
                   @click="goSearch(item)">{{ item }}</v-btn>
            <v-btn icon plain :ripple="false"
                   small class="btn-keyword-delete"
                   @click="delCookie(index)">
              <i class="cu-icon-close"></i>
            </v-btn>
          </li>
        </ul>
      </template>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'LibrarySearchBody',
  components: {},
  mixins: [],
  props: {},
  data: () => ({}),
  computed: {
    searchKeywords () {
      return this.$store.state.library.libraryKeywords
    }
  },
  watch: {},
  created () {},
  activated () {
    this.$emit('onEvent', { fn: 'setLibraryKeywords' })
  },
  methods: {
    goSearch (value) {
      this.$emit('onEvent', { fn: 'onSubmit', params: value })
    },
    delCookie (index = null) {
      this.$store.commit('delLibraryKeywords', index)
    }
  }
}
</script>
